<template>
  <Fragment>
    <div class="content-wrap">
      <header class="content-header content-header--with-search">
        <h3>{{ $t('companies.companyUsers.staff') }}</h3>
        <div v-if="companyUsers.length > 0" class="header-meta">
          <SearchField
            :label="$t('admin.user.searchUser')"
            :name="'user-search-input'"
            :placeholder="$t('companies.companyUsers.searchPlaceholder')"
            v-model="searchPhrase"
            @input="searchHandler"
          />
        </div>
      </header>
      <div class="content-body">
        <LoadingSpinner v-if="loading" />
        <div v-if="!loading && companyUsers.length == 0" class="alert alert-danger">
          {{ $t('companies.companyUsers.noStaff') }}
        </div>
        <div v-else>
          <Table>
            <template #header>
              <th>{{ $t('companies.companyUsers.name') }}</th>
              <th>{{ $t('companies.companyUsers.email') }}</th>
              <th>{{ $t('companies.companyUsers.role') }}</th>
              <th>
                <span class="visually-hidden">{{ $t('meta.actions') }}</span>
              </th>
            </template>
            <template #body>
              <tr v-for="{ user: { first_name, last_name, email }, roles, uuid } in companyUsers" :key="uuid">
                <td>{{ first_name ? first_name : '-' }} {{ last_name ? last_name : '-' }}</td>
                <td>{{ email }}</td>
                <td>{{ mapUserRoles(roles) }}</td>
                <td class="table__actions">
                  <Link :to="`/company/users/${uuid}`" class="table__action-button">
                    <span class="material-icons">edit</span>
                  </Link>
                </td>
              </tr>
            </template>
          </Table>
          <div v-if="pagination && pagination.totalObjects > 0" class="pagination">
            <pagination
              :records="pagination.totalObjects"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              @paginate="getCompanyUsers"
              :options="{ chunk: 5, texts: { count: $t('pagination.text') } }"
            />
          </div>
        </div>
      </div>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import Pagination from 'vue-pagination-2'

import SearchField from '@/components/Form/Search/SearchField.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import Table from '@/components/Table/index.vue'
import stringUtils from '@/components/mixins/stringUtils'

import companyUsersApi from '@/api/companyUsers'

export default {
  name: 'company_users',
  components: {
    Fragment,
    LoadingSpinner,
    Pagination,
    SearchField,
    Table,
  },
  props: {
    companyUuid: { type: String, required: true },
  },
  data() {
    return {
      companyUsers: [],
      searchPhrase: '',
      pagination: {
        page: 1,
        totalObjects: 0,
        perPage: 0,
      },
      loading: true,
      sortOrder: 'ascending',
    }
  },
  mixins: [stringUtils],
  methods: {
    mapUserRoles(roles) {
      return roles ? roles.map(role => this.$t(`meta.roles.${role}`)).join(', ') : '-'
    },
    searchHandler() {
      this.getCompanyUsers(1)
    },
    async getCompanyUsers(page) {
      const currentPage = page || this.pagination.page
      this.loading = true
      const params = { company_uuid: this.companyUuid, page: currentPage, no_admins: true }
      if (this.searchPhrase.length > 0) {
        params['search_phrase'] = this.searchPhrase
      }

      const result = await companyUsersApi.getAll(params)

      if (!result) {
        this.loading = false
        return
      }

      this.companyUsers = result.companyUsers.sort((a, b) =>
        this.compareLocaleString(a.user.last_name, b.user.last_name, this.sortOrder),
      )

      this.pagination.page = currentPage
      this.pagination.totalObjects = result.pagination?.total_objects
      this.pagination.perPage = result.pagination?.per_page
      this.loading = false
    },
  },
  async mounted() {
    await this.getCompanyUsers()
  },
}
</script>
